import { DateTime, Interval } from 'luxon';
import { types } from 'mobx-state-tree';

import TableData from '@common/models/TableData';

const PeriodModel = types
	.compose(
		TableData,
		types.model({
			data: types.optional(types.array(types.frozen()), []),
			period_start: types.maybe(types.string),
			period_end: types.maybe(types.string),
		}),
	)
	.named('PeriodModel')
	.views((self) => ({
		get startDateTime() {
			return DateTime.fromISO(self.period_start).startOf('day');
		},
		get endDateTime() {
			return DateTime.fromISO(self.period_end).endOf('day');
		},
	}))
	.views((self) => ({
		get days() {
			return Interval.fromDateTimes(self.startDateTime, self.endDateTime).splitBy({ days: 1 });
		},
	}))
	.views((self) => ({
		get dates() {
			return self.days.map((day) => day.start.toISODate());
		},
	}))
	.views(() => ({
		get dataMap() {
			return {};
		},
	}));

export default PeriodModel;
